import styled from "styled-components";

export const ActionItemTextStyled = styled.span`
    font-size: 15px; 
    padding-right: 30px; 
    padding-left: 15px;
`
